import { useHasActiveCgmSubscription } from '@src/hooks/useActiveCgmSubscriptions'
import { useIsOwnSensorGlucoseDetected } from '@src/screens/OwnSensorOnboarding/hooks/useIsOwnSensorGlucoseDetected'
import {
  useHasSyncedSteloRealtime,
  useIsDexcomSteloSensorMode,
  useMarkedForTransitionToSteloRealtime,
} from '@src/utils/hooks'

export const useShowPurchasedSteloSetupPopup = () => {
  const isDexcomSteloSensorMode = useIsDexcomSteloSensorMode()
  const hasSyncedSteloRealtime = useHasSyncedSteloRealtime()
  const isMarkedForTransitionToSteloRealtime = useMarkedForTransitionToSteloRealtime()
  const isOwnSensorGlucoseDetected = useIsOwnSensorGlucoseDetected()
  const hasActiveCgmSubscription = useHasActiveCgmSubscription()

  if (!isDexcomSteloSensorMode) {
    return false
  }

  // this is an existing user who has already synced via apple health (should see different popup)
  if (isOwnSensorGlucoseDetected) {
    return false
  }

  // member has never created a stelo connection
  if (hasSyncedSteloRealtime) {
    return false
  }

  if (!hasActiveCgmSubscription) {
    return false
  }

  // member is transitioning from other sensor model, should not see this popup
  return !isMarkedForTransitionToSteloRealtime
}
